<div class="main-container">
  <div class="ribbon" [style.background-image]="'url(' + logoContratUrl + ')'">
  </div>

  <div class="page-container">
    <h1>Documenthèque</h1>

    <div class="left-side">
      <span class="title">Recherche</span>

      <form class="content-container search-form" (submit)="searchDocuments($event)">

        <div class="sub-container text-container">
          <input type="text" id="search-text" name="search-text" [(ngModel)]="searchText" placeholder="Rechercher" />
        </div>

        <div class="sub-container buttons-container">
          <button type="submit" class="generic-button gray-tile-button search-button">Rechercher</button>
        </div>
      </form>
    </div>

    <div class="results-container right-side">
      <span class="title">Derniers documents</span>

      <div class="results-list content-container">
        <div *ngIf="isLoadingDocuments" class="info-container">
          <app-loader message="Chargement des documents..."></app-loader>
        </div>
        <!-- Data -->

        <div class="container-fluid" *ngIf="!isLoadingDocuments">

          <div class="table-row table-header">
            <div class="text">Documents</div>
          </div>

          <div class="table-row" *ngIf="!documents || documents.length == 0">
            Aucun document trouvé
          </div>


          <!-- Define the recursive template. -->
          <ng-template #nodeTemplateRef let-node="node">

            <ng-container *ngIf="!node.isFolder">
              <!-- document template -->
              <div class="table-row table-body" (click)="getDocument(node.document)" [restaurantColor]="{'type': currentType, 'isSecondary':true, 'background':true, 'hover':true}">
                <div class="document-icon">
                  <img src="/assets/images/files/file-outline.png" />
                </div>
                <div class="document text">
                  <div class="document-header">
                    <div class="document-name">{{ node.name }}</div>
                    <div class="document-date">{{ node.document.createdAtString }}</div>
                  </div>

                  <div class="document-description">{{node.document.isDownloading? 'Téléchargement...' : node.document.description}}</div>
                </div>
              </div>
            </ng-container>
            <ng-container *ngIf="node.isFolder">
              <!-- folder template  -->
              <div class="table-row table-body" (click)="node.isOpen = !node.isOpen" [restaurantColor]="{'type': currentType, 'isSecondary':true, 'background':true, 'hover':true}">
                <div class="document-icon">
                  <img [src]="node.isOpen ? '/assets/images/files/folder-open.png' : '/assets/images/files/folder.png'" />
                </div>
                <div class="document text">
                  <div class="document-header">
                    <div class="document-name">{{ node.name }}</div>
                  </div>
                  <div class="document-description">{{node.description}}</div>
                </div>
              </div>
              <div class="container-fluid folder-files" *ngIf="node.isOpen">
                <ng-template ngFor let-child [ngForOf]="node.children">

                  <!-- Invoke the recursive template. -->
                  <ng-template [ngTemplateOutlet]="nodeTemplateRef" [ngTemplateOutletContext]="{ node: child }">
                    <!--
                      Because we are using nested ngTemplates (rather than the template
                      input of the ngFor directive), we have more control over how the
                      data is made available to the recursive template. In this case,
                      we're passing "child" through as "node".
                    -->
                  </ng-template>

                </ng-template>
              </div>
            </ng-container>

          </ng-template>


          <!-- Initiate the recursive template rendering. -->
          <ng-template ngFor let-child [ngForOf]="displayedDocuments">

            <!-- Invoke the recursive template. -->
            <ng-template [ngTemplateOutlet]="nodeTemplateRef" [ngTemplateOutletContext]="{ node: child }">
            </ng-template>

          </ng-template>

        </div>


        <div class="pagination" *ngIf="!isLoadingDocuments && documents && documents.length > 0 && totalPages > 1">
          <button class="generic-button prev-button" (click)="prev()" [class.hidden]="page == 1"></button>
          <button class="generic-button page-button" (click)="changePage(1)" [class.selected-page-button]="page == 1" [restaurantColor]="{'type': currentType, 'background':page == 1}">1</button>
          <span *ngIf="page > 3">...</span>
          <button class="generic-button page-button" (click)="changePage(p)" *ngFor="let p of pages" [class.hidden]="!isPageDisplayed(p)" [class.selected-page-button]="p == page" [restaurantColor]="{'type': currentType, 'background':page == p}">{{p}}</button>
          <span *ngIf="page < totalPages - 2">...</span>
          <button class="generic-button page-button" (click)="changePage(totalPages)" [class.hidden]="totalPages == 1" [class.selected-page-button]="page == totalPages" [restaurantColor]="{'type': currentType, 'background':page == totalPages}">{{totalPages}}</button>
          <button class="generic-button next-button" (click)="next()" [class.hidden]="page == totalPages"></button>
        </div>

      </div>
    </div>

  </div>

</div>
